import styled from "styled-components";
import {CharcoalBlack, DarkSlate, ErrorRed, Silver, Teal, White} from "../../../../theme/variable";
import {validateField} from "../../../../utils/validation";
import {media} from "../../../../theme/responsive.js";

export const CheckboxField = styled.div`
    display: inline-block;
    outline: none;
    ${media.laptop`position:relative`}
`;

export const CheckboxLabel = styled.label`
    position: relative;
    cursor: pointer;
    font-size: 0.9375rem;
    line-height: 24px;
    vertical-align: middle;
    color: ${(props) => (props.disabled ? `${Silver}` : `${CharcoalBlack}`)};
    &:after {
        content: "";
        opacity: 0;
        transform: scale(0);
    }
`;
export const Input = styled.input`
    padding: 0;
    height: initial;
    width: initial;
    margin-bottom: 0;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    background-color: transparent;
    border: ${(props) => {
        if (props.disabled) {
            return `1.5px solid ${Silver}`;
        } else {
            if (props.checked || props.isFocused) return `1.5px solid ${Teal}`;
            if (props.isError) return `1.5px solid ${ErrorRed}`;
        }
        return `1.5px solid ${DarkSlate};`;
    }};
    background: ${White};
    width: 16px;
    height: 16px;
    border-radius: 2px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 6px;
    top: -1px;
    &:focus {
        border: 1.5px solid ${Teal};
    }
    &:checked + ${CheckboxLabel}:before {
        background: ${White};
        border: ${(props) => {
            if (props.disabled) {
                return `1.5px solid ${Silver}`;
            } else {
                if (props.checked) return `1.5px solid ${Teal}`;
            }
            return `1.5px solid ${DarkSlate};`;
        }};
    }
    &:checked:after {
        content: "";
        display: block;
        position: absolute;
        top: ${(props) => {
            if (validateField(props, "object", "CheckBoxStyle.mobile.top"))
                return props.CheckBoxStyle.mobile.top;
            return "1px";
        }};
        left: 4px;
        width: 2px;
        height: 6px;
        border: ${(props) => (props.disabled ? `solid ${Silver}` : `solid ${Teal}`)};
        border-width: 0 2px 2px 0;
        opacity: 1;
        transform: scale(1) rotate(45deg);
        transition: opacity 80ms 0ms cubic-bezier(0.4, 0, 0.6, 1),
            transform 80ms 0ms cubic-bezier(0.4, 0, 0.6, 1);

        ${media.laptop`top:${(props) => {
            if (validateField(props, "object", "CheckBoxStyle.laptop.top"))
                return props.CheckBoxStyle.laptop.top;
            return "1px";
        }};`}
    }
`;
